import { API, METHODS } from '../../constants';
import { fetchData } from '../common/apiCalling';

export const getRefreshToken = async ({ refresh_token, user_email }) => {
    let url = `${API.USER}${API.REFRESH_TOKEN}`;
    return fetchData({ body: { refresh_token, user_email }, method: METHODS.POST, url });
};
